import { Component } from '@angular/core';

@Component({
  selector: 'app-barcode-table',
  templateUrl: './barcode-table.component.html',
  styleUrls: ['./barcode-table.component.css']
})
export class BarcodeTableComponent {
  uid: string;
  tableData;
  barcodeData;
  tableItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  origBarcodeData: any;


  ngAfterViewInit() {
  }

  displayTable(body: any) {
    this.barcodeData = body;
    let color = 'black';
    this.uid = body.uid;
    this.tableData = body.result;

  }

  unchooseTr() {
    if (!this.tableData) return;
    for (let item of this.tableData) {
      item.chosen = false;
    }
  }



  itemFocusout() {

  }

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;


  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    this.unchooseTr();
    this.tableData = null;
  }
}
